// extracted by mini-css-extract-plugin
export default {"block":"Block_block__yn2Au"};